import React from 'react';
import { Modal, SparkModalPortal, Text } from '@spark';
import { lostLabelChoiceCopy } from '../businessGoals/labelsCatalogChange';

/**
 * Warning shown in the create-task wizard after the Fix menu replaced the
 * task labels with what the files hold and the Business Goals choice that
 * pointed at a removed label is gone with it: the Fallback label ("Adjust
 * Fallback") or "What matters most for these labels?" ("Adjust Label
 * Priorities"). The primary button sends the user back to that select; "Not
 * now" keeps the updated labels and stays on Data Collection, where Next
 * shows this again until the choice is made. Same dialog design as the
 * benchmark prompt.
 *
 * `field`, `removedFallback` and `previousPriority` feed
 * `lostLabelChoiceCopy`.
 */
const LostLabelChoiceModal = ({
    open,
    field,
    labels,
    removedFallback,
    previousPriority,
    onAdjust,
    onDismiss,
}) => {
    if (!open || !field) return null;
    const { title, body, primaryLabel } = lostLabelChoiceCopy({
        field,
        labels,
        removedFallback,
        previousPriority,
    });
    return (
        <SparkModalPortal open onClose={onDismiss} size="text" className="cw-dc-benchmark-modal-portal">
            <Modal
                title={title}
                feedbackType="warning"
                showSubtitle={false}
                showScrollBar={false}
                showOverlay={false}
                fixedHeight={false}
                primaryLabel={primaryLabel}
                tertiaryLabel="Not now"
                onPrimaryClick={onAdjust}
                onTertiaryClick={onDismiss}
                onCloseClick={onDismiss}
                className="cw-dc-benchmark-modal"
            >
                <Text variant="base-regular" color="secondary" as="p">
                    {body}
                </Text>
            </Modal>
        </SparkModalPortal>
    );
};

export default LostLabelChoiceModal;
